import {
	DesignerNumberText,
	JobNameOptionalText,
	OrderDetailsText,
	OrderReplacementsPONumber,
	UnavailableDataPlaceholderText
} from "constants/text";
import { RootState } from "stores/application.store";
import { useSelector } from "react-redux";
import { displayDesigner } from "utils/order";
import { Title } from "components/Replacements/components/common.styles";
import { models } from "types/api/viewModels.ts";
import {
	ReplacementReviewEditOrderDetailsContainer,
	ReplacementReviewEditOrderDetailsContent,
	ReplacementReviewEditOrderDetailsData,
	ReplacementReviewEditOrderDetailsFirstRow
} from "./ReplacementReviewEditOrderDetails.styles.ts";

export interface ReviewEditOrderDetailsProp {
	orderDetail: models["OrderDetailViewModel"] | null | undefined;
}

const ReplacementReviewEditOrderDetails = ({ orderDetail }: ReviewEditOrderDetailsProp) => {
	const details = useSelector((state: RootState) => state.submittingReplacementOrder.order);

	return (
		<ReplacementReviewEditOrderDetailsContainer>
			<Title data-testid="replacement-review-order-details-header">{OrderDetailsText}</Title>
			<ReplacementReviewEditOrderDetailsContent>
				<ReplacementReviewEditOrderDetailsFirstRow>
					<ReplacementReviewEditOrderDetailsData>
						<div data-testid="replacement-review-order-details-designerNumber-header">
							{DesignerNumberText}
						</div>
						<span data-testid="replacement-review-order-details-designerNumber">
							{displayDesigner(orderDetail?.designer) ?? UnavailableDataPlaceholderText}
						</span>
					</ReplacementReviewEditOrderDetailsData>
					<ReplacementReviewEditOrderDetailsData>
						<div data-testid="replacement-review-order-details-poNumber-header">
							{OrderReplacementsPONumber}
						</div>
						<span data-testid="replacement-review-order-details-poNumber">
							{details?.poNumber ?? orderDetail?.poNumber}
						</span>
					</ReplacementReviewEditOrderDetailsData>
				</ReplacementReviewEditOrderDetailsFirstRow>
				<ReplacementReviewEditOrderDetailsData>
					<div data-testid="replacement-review-order-details-jobName-header">{JobNameOptionalText}</div>
					<span data-testid="replacement-review-order-details-jobName">
						{details?.jobName ?? orderDetail?.jobName}
					</span>
				</ReplacementReviewEditOrderDetailsData>
			</ReplacementReviewEditOrderDetailsContent>
		</ReplacementReviewEditOrderDetailsContainer>
	);
};

export default ReplacementReviewEditOrderDetails;
